/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';

/**
 * 
 * @export
 * @interface ListDocuments200Response
 */
export interface ListDocuments200Response {
    /**
     * 
     * @type {Array<Document>}
     * @memberof ListDocuments200Response
     */
    items: Array<Document>;
    /**
     * Opaque cursor for fetching the next page. Null when no more results.
     * @type {string}
     * @memberof ListDocuments200Response
     */
    cursor: string;
}

/**
 * Check if a given object implements the ListDocuments200Response interface.
 */
export function instanceOfListDocuments200Response(value: object): value is ListDocuments200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('cursor' in value) || value['cursor'] === undefined) return false;
    return true;
}

export function ListDocuments200ResponseFromJSON(json: any): ListDocuments200Response {
    return ListDocuments200ResponseFromJSONTyped(json, false);
}

export function ListDocuments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDocuments200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DocumentFromJSON)),
        'cursor': json['cursor'],
    };
}

export function ListDocuments200ResponseToJSON(json: any): ListDocuments200Response {
    return ListDocuments200ResponseToJSONTyped(json, false);
}

export function ListDocuments200ResponseToJSONTyped(value?: ListDocuments200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(DocumentToJSON)),
        'cursor': value['cursor'],
    };
}

